import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';
import { ParticleBehaviourTagType, AttractType } from 'app/enum/Particles';
import { ParticleBehaviour } from '../ParticleBehaviour';

export class ParticleAttract extends ParticleBehaviour {
	protected _tags: Array<ParticleBehaviourTagType> = [ParticleBehaviourTagType.ATTRACT];

	private _type: AttractType = AttractType.DIRECT;
	private _target: particles.ParticleTarget;
	private _radius: number;
	private _angle: number; //Current orbit angle (degrees) in circle mode
	private _powerX: number;
	private _powerY: number;
	private _targetPos: geometry.Vector2;
	private _powerEffectX: number;
	private _powerEffectY: number;
	private _onTargetReached: Function;

	//GETTER / SETTER
	//--------------------------------------------------------------------------------------------------
	public set type(type: AttractType) {
		this._type = type;
	}

	public set onTargetReached(v: Function) {
		this._onTargetReached = v;
	}

	public set target(target: particles.ParticleTarget) {
		this._target = target;
		this._targetPos = null;
	}

	public get target(): particles.ParticleTarget {
		return this._target;
	}

	public set radius(radius: number) {
		this._radius = radius;
	}

	public set powerX(power: number) {
		this._powerX = power;
	}

	public set powerY(power: number) {
		this._powerY = power;
	}

	public set targetPos(position: geometry.Vector2) {
		this._targetPos = position;
		this._target = null;
	}

	public set instant(v: boolean) {
	}

	//PUBLIC METHODS
	//-----------------------------------------------------------------------------------------

	public randomiseRadius(base: number, seed: number): void {
		this._radius = base + Math.random() * seed;
	}

	public randomisePowerX(base: number, seed: number): void {
		this._powerX = base + Math.random() * seed;
	}

	public randomisePowerY(base: number, seed: number): void {
		this._powerY = base + Math.random() * seed;
	}

	public tick(): void {
		if (this._type === AttractType.DIRECT) {
			this._tickDirect();
		} else if (this._type === AttractType.ORBIT) {
			this._tickOrbit();
		}
	}

	private _tickDirect(): void {

		if (this._target) {
			this._targetPos = this._target.relativePosition;
		}

		this._powerEffectX = this._targetPos.x - this._particleProps.ref.position.x;
		this._powerEffectY = this._targetPos.y - this._particleProps.ref.position.y;

		if (Math.abs(this._powerEffectX) > this._powerX) {
			this._powerEffectX = this._powerEffectX < 0 ? -this._powerX : this._powerX;
		}

		if (Math.abs(this._powerEffectY) > this._powerY) {
			this._powerEffectY = this._powerEffectY < 0 ? -this._powerY : this._powerY;
		}

		this._particleProps.ref.position.x += this._powerEffectX;
		this._particleProps.ref.position.y += this._powerEffectY;

		if (this._powerEffectX === 0 && this._powerEffectY === 0) {
			if (this._onTargetReached) {
				this._onTargetReached();
			}
		}
	}

	private _tickOrbit(): void {
		if (this._target) {
			this._targetPos = this._target.relativePosition;
		}

		let x = this._particleProps.ref.position.x * this._sceneProps.sizes.container.w;
		let y = this._particleProps.ref.position.y * this._sceneProps.sizes.container.h;
		let cx = this._targetPos.x * this._sceneProps.sizes.container.w;
		let cy = this._targetPos.y * this._sceneProps.sizes.container.h;

		//the distance to the center:
		this._radius = Math.sqrt(Math.pow(x - cx, 2) + Math.pow(y - cy, 2));
		this._radius -= 0.1;
		this._angle = (Math.atan2(y - cy, x - cx) * 180) / Math.PI;
		this._angle += 1;

		let xAbs = cx + this._radius * Math.cos((this._angle * Math.PI) / 180);
		let yAbs = cy + this._radius * Math.sin((this._angle * Math.PI) / 180);


		this._particleProps.ref.position.set({
			x: xAbs / this._sceneProps.sizes.container.w,
			y: yAbs / this._sceneProps.sizes.container.h
		});
	}
}
